import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../lib/motion";
import { ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 pt-20 pb-24 sm:pt-28 sm:pb-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <motion.div {...fadeUp} className="lg:col-span-7">
          <p className="overline mb-8" data-testid="hero-overline">— The Foundation Edit</p>
          <h1 className="font-serif-display font-medium tracking-tight text-[color:var(--charcoal)] text-5xl sm:text-6xl lg:text-7xl leading-[1.05]" data-testid="hero-headline">
            Your business isn't disorganised —
            <span className="italic text-[color:var(--gold)]"> it just hasn't been structured properly.</span>
          </h1>
          <p className="mt-8 max-w-xl text-base sm:text-lg text-[color:var(--text-secondary)] leading-relaxed font-light" data-testid="hero-subheadline">
            The Foundation Edit builds and refines your business backend so you can operate with clarity, confidence, and control.
          </p>
          <p className="mt-4 overline" data-testid="hero-price-anchor">— Business setup &amp; systems, from £1,200</p>
          <div className="mt-12 flex flex-wrap items-center gap-4">
            <a href="#enquire" data-testid="hero-cta-primary" className="btn-primary">
              Apply to Work Together <ArrowRight size={14} strokeWidth={1.25} />
            </a>
            <a href="#packages" data-testid="hero-cta-secondary" className="btn-outline">
              View Packages
            </a>
          </div>
          <div className="mt-16 flex items-center gap-6 text-xs tracking-[0.2em] uppercase text-[color:var(--text-secondary)]">
            <span>Done-for-you setup</span>
            <span className="w-8 h-px bg-[color:var(--border-medium)]" />
            <span>Serving coaches &amp; service-based businesses</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden bg-[color:var(--sand)]">
            <img
              src="/hero-foundation-edit.png"
              alt="Minimal high-end business workspace — partially open laptop, structured notebook, pen, and neatly arranged documents in beige and charcoal tones"
              data-testid="hero-image"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-4 -left-4 hidden sm:block bg-[color:var(--bg-base)] border border-[color:var(--border-light)] px-6 py-4">
            <p className="overline">Est.</p>
            <p className="font-serif-display text-2xl text-[color:var(--charcoal)]">MMXXVI</p>
          </div>
        </motion.div>
      </div>
      <div className="gold-line mx-6 sm:mx-8" />
    </section>
  );
}
